import { Injectable, inject } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AuthStorageService implements OAuthStorage {
  private cookieService = inject(CookieService);

  getItem(key: string): string | null {
    return this.cookieService.get(key) || null;
  }

  setItem(key: string, value: string): void {
    this.cookieService.set(key, value, undefined, '/', undefined, true, 'Strict');
  }

  removeItem(key: string): void {
    this.cookieService.delete(key, '/', undefined, true, 'Strict');
  }
}
